import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import View from './view';
import * as Actions from '../actions';
import { createSelector } from 'redux-orm';
import orm from 'shared_redux/reducers/models/orm';

const getProgram = createSelector(
    orm,
    state => state.database,
    (state, props) => props.match.params.programid,
    (session, programId) => {
        if (!programId) return null;
        return session.Programs.withId(programId);
    }
);

const mapStateToProps = (state, props) => {
    return {
        program: getProgram(state, props),
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        updateProgramSharing: Actions.updateProgramSharing,
        updateProgramContactEmail: Actions.updateProgramContactEmail,
    }, dispatch);
};

const Container = connect(
    mapStateToProps,
    mapDispatchToProps
)(View);

export default Container;